import { AppSettingsService } from './shared/app-settings/app-settings.service';
import { TranslateService } from '@ngx-translate/core';
import { SettingsApi } from './api/api/SettingsApi';

export function setSettingsProvider (
	settingsApi: SettingsApi,
	appSettings: AppSettingsService,
	translate: TranslateService
) {
	return function () {
		return new Promise((resolve, reject) => {
			settingsApi.getAppSettings().subscribe(data => {
				const locale: any = data.user.language;
				appSettings.data = data;

				// Set locale before app bootstraped
				translate.setDefaultLang('ru');
				translate.use(locale).subscribe(() => {
					resolve();
				});
			});
		});
	};
}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/settings.prefetch.ts